<template>
  <v-dialog
    v-model="value"
    persistent
    max-width="290"
  >
    <v-card>
      <v-card-title class="headline">
        {{ $t('CLASS_MODE.DISABLE.TITLE') }}
      </v-card-title>
      <v-card-text>
        <p>
          {{ $t('CLASS_MODE.DISABLE.DESCRIPTION') }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="close"
        >
          {{ $t('CLASS_MODE.DISABLE.NO') }}
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="exit"
        >
          {{ $t('CLASS_MODE.DISABLE.YES') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClassModeModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    code: '',
  }),
  methods: {
    close() {
      this.$emit('input', false);
    },
    exit() {
      this.$store.dispatch('classMode/disable');
      this.$emit('input', false);
      this.$store.dispatch('alerts/show', {
        text: 'Has salido del modo clase',
      });

      this.$track('leave_class_mode', this.$route.name);

      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
    },
  },
};
</script>
